export default {
    'menu.login': 'Giriş',
    'menu.register': 'Kayıt Ol',
    'menu.forgotPassword': 'Şifremi Unuttum',
    'menu.changePassword': 'Şifre Değiştir',
    'menu.apply': 'Başvurularım',
    'menu.logout': 'Çıkış',
    'menu.settings': 'Ayarlar',
    'menu.settings.profile': 'Profil',
    'menu.settings.appearance': 'Görünüm',
    'menu.settings.notifications': 'Bildirimler',
    'menu.settings.access': 'Erişim',
    'menu.settings.access.emails': 'E-postalar',
    'menu.settings.access.security': 'Şifre ve kimlik doğrulama',
    'menu.admin': 'Yönetim',
    'menu.admin.applications': 'Başvurular',
};
